import { EModeCategory } from '../types'
import { Badge } from '@/ui/atoms/badge/Badge'
import { TileButton } from '@/ui/atoms/tile-button/TileButton'
import { IconStack } from '@/ui/molecules/icon-stack/IconStack'

interface EModeCategoryTileProps {
  eModeCategory: EModeCategory
}

export function EModeCategoryTile({ eModeCategory }: EModeCategoryTileProps) {
  if (eModeCategory.tokens.length === 0) {
    return null
  }

  const iconPaths = eModeCategory.tokens.map((token) => token.logo)
  const variant = eModeCategory.isActive ? 'active' : 'inactive'

  return (
    <TileButton
      onClick={eModeCategory.onSelect}
      isSelected={eModeCategory.isSelected}
      className="grid grid-rows-3 items-center justify-start gap-2 text-start"
    >
      <Badge variant={variant === 'active' ? 'success' : 'neutral'} appearance="soft" size="sm">
        {variant === 'active' ? 'Active' : 'Inactive'}
      </Badge>
      <h4 className="typography-label-2">{eModeCategory.name}</h4>
      <IconStack items={iconPaths} maxIcons={4} />
    </TileButton>
  )
}
